import { useMemo } from "react";
import { FileUploadStatus } from "../../../ducks/file";
import { getFileStatusText } from "../../../utils/file";
import { Badge } from "../../atoms/Badge";

type Props = {
  status: FileUploadStatus;
};
export const FileStatus: React.FC<Props> = ({ status }) => {
  const badgeVariant = useMemo(() => {
    switch (status) {
      case FileUploadStatus.Waiting:
      case FileUploadStatus.Processing:
        return "processing";
      case FileUploadStatus.Success:
        return "success";
      case FileUploadStatus.SystemError:
      case FileUploadStatus.DataError:
      case FileUploadStatus.UploadError:
        return "error";
      default:
        return "error";
    }
  }, [status]);

  return <Badge text={getFileStatusText(status)} variant={badgeVariant} />;
};
